exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".color-example {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  margin: 20px 0; }\n  .color-example > .color-cube {\n    width: 30%;\n    height: 100px;\n    flex-shrink: 0;\n    color: rgba(255, 255, 255, 0.85);\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    flex-direction: column;\n    border-radius: 4px;\n    padding-left: 20px; }\n    .color-example > .color-cube > .title {\n      font-size: 20px;\n      font-weight: 600;\n      margin-bottom: 10px; }\n    .color-example > .color-cube > .detail {\n      font-size: 16px;\n      font-weight: 600; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/style/Color.scss
// module id = 87
// module chunks = 0